<template>
  <main class="content-container" ref="container">
    <div class="list-container">
      <ul id="id-arts" class="note-list">
        <li v-for="article in articles">
          <div class="content">
            <nuxt-link class="title" :to="{name: 'book-uid-detail', params: {uid: article.uid, detail: article.id}}">{{ getTitle(article.article_id) }}</nuxt-link>
            <p class="abstract">
              {{ article.abstract }}
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div id='id-paging' class="page-btn">
      <el-pagination background layout="prev, pager, next" :total="total" :pager-count="5" :page-size="page_size" :current-page="current_page" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </main>
</template>

<script>
  import { getTitleFromPath } from '~/utils/tools'

  export default {
    async asyncData ({ store, params }) {
      let pageNo = parseInt(params.pageNo);
      if (!pageNo) pageNo = 1;
      return store.dispatch('article/getCatalog', parseInt(pageNo)).then(res => {
        return {
          articles: res.data,
          total: res.page_total,
          page_size: res.paging_offset,
          current_page: parseInt(pageNo)
        }
      })
    },
    head() {
      return {
        title: "笔记列表索引"
      }
    },
    data () {
      return {
        articles: []
      }
    },
    methods: {
      getTitle(path) {
        return getTitleFromPath(path);
      },

      handleCurrentChange(val) {
        this.$router.push({
          name: "catalog-pageNo",
          params: {pageNo: val}
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  /* 导入全局样式变量 */
  @import '~assets/stylus/variable.styl'

  .page-btn
    margin-bottom 30px
    text-align right
    overflow hidden
  .list-container
    background color_white
    padding 0 15px
    margin-top 10px
    border-radius border_radius
    margin-bottom 15px;

  .note-list
    margin 0
    padding 10px
    list-style none

  .note-list li
    position: relative;
    width: 100%;
    margin: 0 0 15px;
    padding: 15px 0px 20px 0;
    border-bottom: 1px solid #f0f0f0;
    word-wrap: break-word;

  .note-list .title
    margin: -7px 0 4px;
    display: inherit;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.5;

  .note-list .abstract
    margin: 0 0 8px;
    font-size: 13px;
    line-height: 24px;
    color: minor_text_color;

  /deep/ .el-pager li:not(.disabled).active {
    background: base_color !important;
  }
  /deep/ .el-pager li:hover {
    color: base_color !important;
  }
  @media (max-width 980px) {
    .list-container {
      margin-top 0
    }
  }
</style>
